module.exports = __webpack_public_path__ + "static/media/city1.08331754.jpg";